import { Button, Card, Col, Form, Input, Row, Space } from 'antd';
import { useForm } from '@refinedev/antd';
import { IExperienceEvent } from '../../../interfaces/experience';
import { RichTextInput } from '../../../components/form-item/RichTextInput';

const fields = ['id', 'richAbstract', 'richDetail'];

export const RichForm = () => {
  const { formProps, form, mutationResult, queryResult } = useForm<IExperienceEvent>({
    resource: 'experienceEvents',
    action: 'edit',
    redirect: false,
    meta: {
      fields,
    },
    mutationMeta: {
      fields: [{ experienceEvent: fields }],
    },
  });

  const isLoading = queryResult?.isLoading || mutationResult?.isLoading;

  return (
    <Row gutter={[16, 16]}>
      <Col xl={12} lg={24} xs={24}>
        <Form data-test-id="RichForm" layout="vertical" {...formProps}>
          <Card
            title="詳細ページ"
            extra={
              <Space align="end">
                <Button type="primary" htmlType="submit" loading={isLoading}>
                  保存
                </Button>
                <Button onClick={() => form.resetFields()}>リセット</Button>
              </Space>
            }
          >
            <Form.Item label="詳細ページ(概要)" name="richAbstract">
              <RichTextInput />
            </Form.Item>
            <Form.Item label="詳細ページ(詳細)" name="richDetail">
              <RichTextInput />
            </Form.Item>
          </Card>
        </Form>
      </Col>

      <Col xl={12} lg={24} xs={24}></Col>
    </Row>
  );
};
